import React from 'react';
import { colors } from 'styleguide/colors';
import { FlexRow } from 'styleguide/Row';
import { Spacing } from 'styleguide/spacing';
import { P4 } from 'styleguide/Texts';
import { MicroIcon } from 'styleguide/Icons';
import { t } from 'translations/t';

interface OnlyYouIndicatorProps {
  tint?: string;
  isCoached?: boolean;
}

export const OnlyYouIndicator = ({ tint, isCoached }: OnlyYouIndicatorProps) => {
  const themeColorOverride = {
    dark: tint || colors.greyHiperDark,
    light: tint || colors.greyHiperDark,
  };
  return (
    <FlexRow style={{ gap: Spacing.xs / 2 }}>
      <MicroIcon type="padlock" {...themeColorOverride} />
      <P4 style={{ color: tint }}>
        {isCoached ? t('web.onlyYou.onlyYouAndCoach') : t('web.onlyYou.onlyYou')}
      </P4>
    </FlexRow>
  );
};
